import * as React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";

/**
 * HelpTooltip Component
 * A subtle, non-intrusive contextual help icon that shows helpful information on hover.
 * 
 * Props:
 * - content: The help text to display (required)
 * - side: Position of tooltip ("top" | "right" | "bottom" | "left") - default "top"
 * - size: Icon size ("sm" | "md") - default "sm"
 * - className: Additional CSS classes for the wrapper
 */
export const HelpTooltip = ({ 
  content, 
  side = "top", 
  size = "sm",
  className = "" 
}) => {
  const iconSize = size === "sm" ? 14 : 16;
  
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span 
            className={`help-tooltip-trigger ${className}`}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'help',
              marginLeft: '0.35rem',
              opacity: 0.45,
              transition: 'opacity 0.15s ease',
              verticalAlign: 'middle',
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.85'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '0.45'}
          >
            <HelpCircle 
              size={iconSize} 
              strokeWidth={1.75}
              style={{ color: '#64748b' }}
            />
          </span>
        </TooltipTrigger>
        <TooltipContent 
          side={side}
          className="help-tooltip-content"
          style={{
            maxWidth: '280px',
            padding: '0.625rem 0.875rem',
            fontSize: '0.8125rem',
            lineHeight: '1.45',
            backgroundColor: '#1e293b',
            color: '#f1f5f9',
            border: 'none',
            borderRadius: '6px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          }}
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default HelpTooltip;
